export default __webpack_public_path__ + "static/961-dd236b0b8b7e7b7208b941bf5e647d4e.gif";